import { Outlet, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { TOKEN, useAuthContext } from '../contexts/authContext';
import { EXPIRATIONTOKEN, SIGNIN } from './paths';
import { LayoutDefault } from '../components/layout/default/layoutDefault';

export default function PublicRoute() {
    const { tokenAuth, logout } = useAuthContext();
    const { expirationToken } = useSelector((state: RootState) => state.auth);

    if (expirationToken) {
        localStorage.removeItem(TOKEN);
        logout();
        return <Navigate to={EXPIRATIONTOKEN} />;
    }

    if (!tokenAuth) {
        return <Navigate to={SIGNIN} />;
    }

    return (
        <LayoutDefault>
            <Outlet />
        </LayoutDefault>
    );
}
